import { Icon } from "components/Icon/Icon";

import { TooltipWrapper, TooltipWrapperProps } from "./TooltipWrapper";

export const InfoTooltip = (props: Omit<TooltipWrapperProps, "children">) => (
  <TooltipWrapper {...props}>
    <Icon name="info" size={24} />
  </TooltipWrapper>
);
